<template>
  <a-menu
    v-model="meeting_filter"
    offset-y
    close-on-content-click
    dense
    :disabled="meetingTypeItems.length == 0"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom :disabled="isDisabled">
        <template v-slot:activator="{ on: tooltip }">
          <a-btn
            :min-width="listWidth"
            v-bind="attrs"
            v-on="{ ...menu, ...tooltip }"
            :text="btnText"
            :color="btnText !== true ? 'primaryDark' : ''"
            :disabled="meetingTypeItems.length == 0"
            class="btn-gray-theme"
            :small="isSmall"
          >
            <v-icon left>mdi-filter</v-icon>{{ btnLabel }}
            <v-icon v-if="meeting_filter" right>mdi-chevron-up</v-icon>
            <v-icon v-else right>mdi-chevron-down</v-icon>
          </a-btn>
        </template>
        <span v-html="$t('agenda.tipMeetingFilter')"></span>
      </v-tooltip>
    </template>
    <v-list id="filterId" dense>
      <v-list-item-group mandatory no-action v-model="filter_selected">
        <v-list-item @click.stop="filterBy('upcoming')">
          <v-list-item-content>
            {{ $t("agenda.lbShowUpcoming") }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.stop="filterBy('month')">
          <v-list-item-content>
            {{ $t("agenda.lbPastMonth") }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.stop="filterBy('quarter')" :active="true">
          <v-list-item-content>
            {{ $t("agenda.lbPastQuarter") }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.stop="filterBy('year')">
          <v-list-item-content>
            {{ $t("agenda.lbPastYear") }}
          </v-list-item-content>
        </v-list-item>

        <v-divider v-if="default_filter == 'custom'"></v-divider>

        <v-menu
          v-model="customMenu"
          offset-y
          :close-on-content-click="false"
          dense
        >
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              v-on="on"
              v-bind="attrs"
              @click.stop="filterBy('custom')"
            >
              <v-list-item-content>
                {{ $t("agenda.lbCustom") }}
              </v-list-item-content>
              <v-icon v-if="customMenu" right>mdi-menu-up</v-icon>
              <v-icon v-else right>mdi-menu-down</v-icon>
            </v-list-item>
            <v-divider v-if="default_filter == 'custom'"></v-divider>
          </template>
          <v-card>
            <v-form ref="refdaterange" v-model="validDate" lazy-validation>
              <v-list-item v-if="default_filter == 'custom'" no-action>
                <v-list-item-content>
                  <v-menu
                    v-model="calmenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model.trim="from_date"
                        prepend-icon="mdi-calendar"
                        @click:prepend="calmenu = true"
                        dense
                        :label="$t('lblForm')"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="fromRule"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="from_date"
                      :locale="selectedLang"
                      color="appMenu lighten-1"
                      @input="calmenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="default_filter == 'custom'" no-action>
                <v-list-item-content>
                  <v-menu
                    v-model="calmenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    dense
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model.trim="to_date"
                        prepend-icon="mdi-calendar"
                        @click:prepend="calmenu2 = true"
                        :label="$t('lblTo')"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="toRule"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="to_date"
                      :locale="selectedLang"
                      :min="from_date"
                      @input="calmenu2 = false"
                      color="appMenu lighten-1"
                    ></v-date-picker>
                  </v-menu>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                style="cursor: default"
                v-if="default_filter == 'custom'"
                no-action
                dense
              >
                <v-list-item-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="pageHeader"
                        v-bind="attrs"
                        v-on="on"
                        small
                        dark
                        @click.stop="customDateRange"
                      >
                        <v-icon small> mdi-filter </v-icon>
                        {{ $t("lblFilter") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("search.tipFilterRecords") }}</span>
                  </v-tooltip>
                </v-list-item-title>
              </v-list-item>
            </v-form>
          </v-card>
        </v-menu>
      </v-list-item-group>
    </v-list>
  </a-menu>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
export default {
  name: "MeetingFilter",
  props: {
    section: {
      type: String,
      default: "meeting", //agenda | meeting
    },
    btnText: {
      type: Boolean,
      default: true,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ABtn,
    AMenu,
  },
  data() {
    return {
      isDisabled: false,
      currentDate: new Date().toISOString().slice(0, 10),
      validDate: true,
      meeting_filter: false,
      default_filter: "upcoming",
      filter_selected: this.listNumber(),
      visitDate: [
        (v) =>
          this.from_date <= this.to_date || this.$t("agenda.visitDateValidate"),
      ],
      fromRule: [(v) => !!v || this.$t("agenda.fromDateRequired")],
      toRule: [(v) => !!v || this.$t("agenda.toDateRequired")],
      calmenu: false,
      calmenu2: false,
      from_date: "",
      to_date: "",
      customMenu: false,
      clearDate: false,
      listWidth: 280,
    };
  },
  computed: {
    selectedLang() {
      return this.$i18n.locale;
    },
    ...mapState({
      defaultMeettingFilter: (state) => state.meeting.default_meetting_filter,
    }),
    ...mapGetters({
      getFilterData: "meeting/getFilterData",
      getAgendaFilterData: "agenda/getFilterData",
      meetingTypesList: "tenant/agendaMeetingTypes",
    }),
    isCustom() {
      return this.default_filter === "custom" ? true : false;
    },
    meetingTypeItems() {
      return this.meetingTypesList.filter((item) => {
        if (this.$security.checkMeetingTypeAccess(item.id, "ViewMeeting")) {
          return item;
        }
      });
    },
    btnLabel() {
      const filterData =
        this.section == "agenda"
          ? this.getAgendaFilterData
          : this.getFilterData;
      if (filterData.filter_type == "upcoming") {
        return this.$t("agenda.lbShowUpcoming");
      } else if (filterData.filter_type == "month") {
        return this.$t("agenda.lbPastMonth");
      } else if (filterData.filter_type == "quarter") {
        return this.$t("agenda.lbPastQuarter");
      } else if (filterData.filter_type == "year") {
        return this.$t("agenda.lbPastYear");
      } else if (filterData.filter_type == "custom") {
        return this.$t("agenda.lbCustom");
      } else {
        return this.$t("agenda.lbPastMonth");
      }
    },
  },
  watch: {
    meeting_filter(value) {
      this.isDisabled = value ? true : false;
      setTimeout(() => {
        this.listWidth = document.getElementById("filterId").offsetWidth;
        if (this.listWidth) {
          if (this.listWidth < 185) {
            this.listWidth = 185;
          }
        }
        if (
          value == true &&
          this.isCustom &&
          this.btnLabel == this.$t("agenda.lbCustom")
        ) {
          this.customMenu = true;
        }
      }, 100);
    },
    customMenu(value) {
      if (!value && this.clearDate) {
        this.$refs.refdaterange.reset();
        this.$refs.refdaterange.resetValidation();
      }
    },
    from_date(date) {
      if (date > this.to_date && this.to_date != "") {
        this.to_date = "";
      }
      // this.currentDate = this.from_date;
    },
    getFilterData(filterData) {
      if (this.section != "agenda") {
        this.selection(filterData);
      }
    },
    getAgendaFilterData(filterData) {
      if (this.section == "agenda") {
        this.selection(filterData);
      }
    },
  },
  mounted() {
    const filterData =
      this.section == "agenda" ? this.getAgendaFilterData : this.getFilterData;
    this.selection(filterData);
  },
  methods: {
    ...mapActions({
      setDefaultFilterApi: "meeting/setDefaultFilterType",
      setAgendaDurationFilterApi: "agenda/setAgendaDurationFilter",
      getMeetingListApi: "meeting/getMeetingList",
    }),
    filterBy(filterType) {
      this.default_filter = filterType;
      if (this.default_filter != "custom") {
        this.from_date = "";
        this.to_date = "";
        this.getFilteredMeetings();
        this.meeting_filter = false;
      }
    },
    async getFilteredMeetings() {
      let formData = {};
      this.$emit("isLoader", true);
      if (this.default_filter == "custom") {
        const start_date = this.from_date;
        const end_date = this.to_date;
        formData = {
          filter_type: this.default_filter,
          start_date: start_date,
          end_date: end_date,
        };
      } else {
        formData = { filter_type: this.default_filter };
      }
      formData.section = this.section;
      if (this.section == "agenda") {
        this.setAgendaDurationFilterApi(formData);
      } else {
        await this.setDefaultFilterApi(formData);
      }
      this.$emit("isLoader", false);
    },
    customDateRange() {
      this.default_filter = "custom";
      if (this.$refs.refdaterange.validate()) {
        this.getFilteredMeetings();
        this.meeting_filter = false;
        this.clearDate = false;
      } else {
        this.clearDate = true;
      }

      //this.$refs.dialog.save(date)
      // this.custom_dates = date
      // this.date_range_model = false
      //this.getFilteredMeetings()
    },
    selection(filterData) {
      this.default_filter = filterData.filter_type;
      this.filter_selected = this.listNumber();
      if (filterData && filterData.filter_type == "custom") {
        this.from_date = filterData.start_date;
        this.to_date = filterData.end_date;
      }
    },
    listNumber() {
      return this.default_filter == "upcoming"
        ? 0
        : this.default_filter == "month"
        ? 1
        : this.default_filter == "quarter"
        ? 2
        : this.default_filter == "year"
        ? 3
        : this.default_filter == "custom"
        ? 4
        : 0;
    },
  },
};
</script>

<style>
</style>